
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/liquidity/wizard",
      function () {
        return require("private-next-pages/liquidity/wizard/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/liquidity/wizard"])
      });
    }
  